import React from 'react';
import { motion } from 'framer-motion';

const Results = () => {
  return (
    <section id="results" className="bg-white py-16 md:py-32 section-curve-up">
      <div className="max-w-[1400px] mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }} 
          viewport={{ once: true }} 
          className="mb-12 md:mb-24 text-center" 
        >
          <h2 className="text-4xl md:text-7xl font-black text-black tracking-tighter leading-none mb-4 md:mb-6 uppercase">
            PROVEN <span className="italic text-black/20">IMPACT</span>
          </h2>
          <motion.div 
            initial={{ width: 0 }} 
            whileInView={{ width: "4rem" }} 
            transition={{ delay: 0.3, duration: 0.8 }} 
            viewport={{ once: true }} 
            className="h-[4px] md:h-[6px] bg-[#BEF264] mx-auto" 
          />
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-12 mb-16 md:mb-32">
          {[
            { val: "12M+", label: "Aggregate Views" },
            { val: "3.5X", label: "Retention Spike" },
            { val: "100%", label: "In-House Production" },
            { val: "0", label: "Missed Deadlines" }
          ].map((stat, i) => (
            <motion.div key={i} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.1, duration: 0.5 }} viewport={{ once: true }} className="text-center" >
              <div className="text-4xl md:text-8xl font-black text-black tracking-tighter mb-1 md:mb-4 italic"> {stat.val} </div>
              <div className="text-[7px] md:text-[10px] font-black uppercase tracking-[0.3em] md:tracking-[0.4em] text-black/40"> {stat.label} </div>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="max-w-4xl mx-auto border-l-4 md:border-l-8 border-[#BEF264] pl-5 md:pl-12 py-3 md:py-8" >
          <p className="text-lg md:text-4xl font-black text-black italic leading-[1.2] md:leading-[1.15] tracking-tight uppercase">
            "Consistent, high-quality video editing that keeps your content on-brand and on schedule."
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Results;